import createReducer from "rdx/utils/createReducer";
import types from "rdx/types";

const init = {
  verifyEmailStatus: "idle",
  verifyStripeError: null,
};

export default {
  emailVerification: createReducer(init, {
    [types.SET_VERIFY_EMAIL_STATUS](state, action) {
      return {
        ...state,
        verifyEmailStatus: action.payload,
      };
    },
    [types.SET_VERIFY_STRIPE_ERROR](state, action) {
      return {
        ...state,
        verifyStripeError: action.payload,
      };
    },
    // INSERTION_PT (for script, do not remove)
  }),
};
